import { useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "@phosphor-icons/react";
import { useApi } from "@/lib/api";

const ts = (iso) => new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
const Num = ({ n, testid }) => <td data-testid={testid} className={`px-3 py-2 font-mono text-right ${n ? "text-[#FFB800]" : "text-[#4A4A4A]"}`}>{n}</td>;

export default function AdminUsage() {
  const api = useApi();
  const { data, error, isLoading } = useQuery({ queryKey: ["admin-usage"], queryFn: () => api.get("/admin/usage"), retry: false });
  if (isLoading) return <p className="text-sm text-[#A3A3A3]">Loading…</p>;
  if (error) return <p data-testid="admin-usage-denied" className="text-sm text-[#A3A3A3]">This page is only available to admins.</p>;
  return (
    <div data-testid="admin-usage-page" className="max-w-5xl">
      <p className="font-mono text-xs text-[#A3A3A3] flex items-center gap-2"><ShieldCheck className="text-[#00FF9D]" /> ADMIN · LAST 30 DAYS</p>
      <h1 className="font-display text-3xl md:text-4xl font-semibold mt-1">Limit hits</h1>
      <p className="mt-3 text-sm text-[#A3A3A3]">Accounts that ran into their daily Calibrator limit or weekly email caps, most often first. Counting started when this view went live.</p>
      <div className="mt-8 rounded-xl border border-[#2A2A2A] bg-[#121212] overflow-x-auto">
        {data.accounts.length === 0 ? <p data-testid="admin-usage-empty" className="p-6 text-sm text-[#A3A3A3]">No limits hit yet.</p> : (
          <table className="w-full text-sm">
            <thead className="text-[11px] uppercase tracking-wider text-[#A3A3A3] border-b border-[#2A2A2A]">
              <tr><th className="text-left px-6 py-3">Account</th><th className="text-left px-3 py-3">Plan</th><th className="text-right px-3 py-3">AI daily</th>
                <th className="text-right px-3 py-3">New investors</th><th className="text-right px-3 py-3">Board sends</th><th className="text-right px-3 py-3">Total</th><th className="text-left px-3 py-3">Last hit</th></tr>
            </thead>
            <tbody className="divide-y divide-[#1E1E1E]">
              {data.accounts.map((a) => (
                <tr key={a.user_id} data-testid={`admin-usage-row-${a.user_id}`}>
                  <td className="px-6 py-2 font-mono text-xs whitespace-nowrap">{a.email || a.user_id}</td>
                  <td className="px-3 py-2 text-xs uppercase text-[#00FF9D]">{a.plan || "—"}</td>
                  <Num n={a.ai_daily} testid={`admin-usage-ai-${a.user_id}`} />
                  <Num n={a.investor_adds} testid={`admin-usage-investors-${a.user_id}`} />
                  <Num n={a.board_sends} testid={`admin-usage-board-${a.user_id}`} />
                  <td className="px-3 py-2 font-mono text-right text-white">{a.total}</td>
                  <td className="px-3 py-2 text-xs text-[#A3A3A3] whitespace-nowrap">{ts(a.last_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
